import React, { useEffect, useState } from "react"
import FilterCheckbox from '../../FilterButtons/FilterCheckbox'

export default function ProjectsFilterButtons({ projects, setFilteredProjects }) {
    const [ sectorAnchorEl, setSectorAnchorEl ] = useState(null)
    const [ tickerAnchorEl, setTickerAnchorEl ] = useState(null)
    const [filtered, setFiltered] = useState({ sector: [], stock: [] })
    
    const handleFiltered = (val, key) => setFiltered((filter) => ({ ...filter, [key]:val }))
    
    useEffect(() => {
        const projectsFilter = (projectId) => (
            filtered.stock.includes(projectId)
            && filtered.sector.includes(projectId)
        )
        if (projects) {
            const filteredProjects = projects
                .map(item => item.uuid)
                .filter(projectsFilter)
            return setFilteredProjects(filteredProjects)
        }
        return () => {}
    }, [projects, filtered, setFilteredProjects]) // eslint-disable-line

    const handeFilteredSector = (val) => handleFiltered(val, 'sector')
    const handeFilteredStock = (val) => handleFiltered(val, 'stock')

    return (
        <div className="projectsFilterButtons">
            <FilterCheckbox
                filterItems={projects}
                returnFilteredItems={handeFilteredSector}
                filterKey="sector"
                filterLabel="Sector"
                menuAnchorEl={sectorAnchorEl}
                setMenuAnchorEl={setSectorAnchorEl}
            />
            <FilterCheckbox
                filterItems={projects}
                returnFilteredItems={handeFilteredStock}
                filterKey="ticker"
                filterKeyArray="competitors"
                filterLabel="Stock"
                menuAnchorEl={tickerAnchorEl}
                setMenuAnchorEl={setTickerAnchorEl}
            />
        </div>
    )

}